import { isAfter, parseISO } from "date-fns";
import { SelectedVersionType, Version } from "Types";
import { isApproved } from "Utils";

type ReleasedVersion = Version & {
  software_info: { release_date: string };
};

const isReleased = (version: Version): version is ReleasedVersion =>
  version.software_info.release_date !== null;

export const getVersionByType = (
  versions: Version[],
  type: SelectedVersionType,
): Version | undefined => {
  switch (type) {
    case "approved":
      return versions.find((version) => isApproved(version.approval_status));
    case "released":
      return versions
        .filter(isReleased)
        .reduce<ReleasedVersion | undefined>((latest, version) => {
          if (
            latest === undefined ||
            isAfter(
              parseISO(version.software_info.release_date),
              parseISO(latest.software_info.release_date),
            )
          ) {
            return version;
          }

          return latest;
        }, undefined);
    case "uploaded":
      return versions[0];
  }
};
